import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import BrandHeader from "../../components/BrandHeader";
import api from "../../lib/api"; 

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSubmitted(true);
      toast.success("Password reset link sent!");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="px-6 pt-12 pb-10 fade-up max-w-xl mx-auto">
      <BrandHeader size="lg" />
      <div className="h-16" />

      <Link to="/auth/login" className="flex items-center gap-2 text-sm font-bold text-zinc-500 hover:text-zinc-900 mb-6 w-fit transition-colors">
        <ArrowLeft className="w-4 h-4" /> Back to login
      </Link>

      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter leading-none text-zinc-950 mb-4">
        Reset your <span className="text-blue-600">password</span>.
      </h1>
      
      {!submitted ? (
        <>
          <p className="text-zinc-500 mb-8 font-medium">
            Enter the email address associated with your account and we'll send you a link to reset your password.
          </p>

          <form onSubmit={submit} className="flex flex-col gap-5">
            <div className="flex flex-col gap-1.5">
              <label className="text-sm font-bold text-zinc-900">Email</label>
              <input
                type="email"
                required
                className="ls-input"
                placeholder="you@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="h-14 w-full mt-2 bg-blue-600 text-white text-lg font-bold rounded-lg flex items-center justify-center transition-colors hover:bg-blue-700 active:scale-[0.98] disabled:opacity-60"
            >
              {loading ? "Sending link…" : "Send reset link"}
            </button>
          </form>
        </>
      ) : (
        <div className="p-6 bg-green-50 border border-green-100 rounded-xl mt-8">
          <h3 className="font-bold text-green-900 mb-2">Check your email</h3>
          <p className="text-green-800 text-sm">
            If an account exists for <strong>{email}</strong>, we have sent a password reset link. Please check your inbox and spam folder.
          </p>
        </div>
      )}
    </div>
  );
}